const updateVisibleGuideModal = {
    namespaced: true,
    state: {
        isGuidesModalVisible: false,
        guideKey: null
    },
    mutations: {
        UPDATE_GUIDES_MODAL_VISIBLE(state, payload) {
            state.isGuidesModalVisible = payload.isGuidesModalVisible;
            state.guideKey = payload.guideKey;
        }
    },
    actions: {
        updateGuidesModalVisible: function({ commit }, payload) {
            commit("UPDATE_GUIDES_MODAL_VISIBLE", payload);
        }
    }
}

export default updateVisibleGuideModal;